<template>
  <div class="swiper_wrap" v-if="list.length > 0">
    <Swipe class="my-swiper" :autoplay="5000"  @change="swiperChange">
      <SwipeItem v-for="(item, index) in list" :key="index">
        <a :href="item.url" v-if="item.url">
          <img :src="item.covers" v-load="'oTopicBanner'" />
        </a>
        <img v-else :src="item.covers" v-load="'oTopicBanner'" />
        <div class="swiper-tool" v-if="item.enabledCountdown&&item.day>0">{{item.content}}</div>
      </SwipeItem>
    </Swipe>
    <!-- <div class="default_img" v-else>
      <img src="@assets/img/empty.png" />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Swipe, SwipeItem } from "vant";
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "pageBanner",
  props: {
    list: {
      type: Array,
      default () {
        return [

        ]
      }
    }
  },
  data () {
    return {
    };
  },
  components: { Swipe, SwipeItem },
  computed: {
    ...mapGetters({}),
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  created () {
    console.log(this.list, 'bannnnnn')
  },
  mounted () {
  },
  methods: {
    ...mapActions({}),
    swiperChange (e) {
      this.$Bus.$emit('bannerChange', this.list[e].covers);
    }
  },
  watch: {

  }
};
</script>

<style scoped lang='scss'>
.swiper_wrap {

  // height:3.64rem;
  .default_img {
    margin: 0 10px;
    border-radius: 5px;
    height: 3.8rem;

    img {
      border-radius: 5px;
      display: block;
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
  }
}

.my-swiper {
  height: 100%;
  // width: 100%;
  margin: 0 0.2rem;
  border-radius: 5px;

  img {
    border-radius: 5px;
    display: block;
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }
}

.swiper-container {
  font-size: 0;
}

.swiper-slide {
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
}

.swiper-tool {
  height: 0.52rem;
  display: flex;
  align-items: center;
  background-color: rgba(#000, .35);
  border-radius: 13px 0 0 13px;
  padding: 0 0.3rem;
  font-size: 0.2rem;
  color: #fff;
  position: absolute;
  top: 0.21rem;
  right: 0;
}
</style>
 